import { Box } from '@mui/material';
import { Icon } from '@sdb/planning-ui';
import { t } from 'i18next';

const TaskListAllDone = () => {
  return (
    <Box
      paddingY={2}
      fontSize={14}
      fontStyle="italic"
      display="flex"
      flexDirection="column"
      gap={1}
      justifyContent="center"
      alignItems="center"
      width={1}
    >
      <Icon type="inbox" fontSize="medium" color="primary" />
      {t('taskList.taskDone')}
    </Box>
  );
};

export default TaskListAllDone;
